import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { mysqlDateToArabic } from "../../helpers";
import { MergeRequest } from "../MergeRequestsPage/index";

const Container = styled.div`
    user-select: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 60px;
`;

const Heading = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 47%;
    padding: 15px 1.5% 10px 0;
    font-size: 20px;

    &:first-of-type {
        justify-content: flex-end;
    }
`;

const Divider = styled.div`
    position: relative;
    border-left: 1px solid #ccc;

    &:before {
        position: absolute;
        content: " ";
        top: -1px;
        left: -6px;
        width: 11px;
        height: 1px;
        background-color: #ccc;
    }
`;

const Name = styled.div`
    padding-top: 30px;
    border-top: 1px solid #ccc;
    flex: 0 0 100%;
    font-size: 24px;
    text-align: center;
`;

const CreatedAt = styled.div`
    flex: 0 0 100%;
    font-size: 18px;
    text-align: center;
`;

const TimeRef = styled.div`
    position: relative;
    font-size: 16px;

    &:before,
    &:after {
        position: absolute;
        content: " ";
    }
`;
const Present = styled(TimeRef)`
    margin-left: 40px;

    &:after {
        left: -23px;
        top: 5px;
        width: 0;
        height: 0;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-left: 7px solid #ccc;
    }
`;
const Future = styled(TimeRef)`
    margin-right: 40px;

    &:before {
        right: -23px;
        top: 5px;
        width: 0;
        height: 0;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 7px solid #ccc;
    }
`;

type Props = {
    request: MergeRequest;
};

export default class People extends React.Component<Props> {
    render() {
        const { request } = this.props;
        return (
            <Container>
                <Heading>
                    <Present>
                        <FormattedMessage id="merge.present" />
                    </Present>{" "}
                    {request.src_user_name}
                </Heading>
                <Divider />
                <Heading>
                    {request.dst_user_name}{" "}
                    <Future>
                        <FormattedMessage id="merge.future" />
                    </Future>
                </Heading>
                <Name>{request.name}</Name>
                <CreatedAt>
                    {mysqlDateToArabic(new Date(request.created_at))}
                </CreatedAt>
            </Container>
        );
    }
}
